<template>
  <TextInputCommon
    v-model="modelValue"
    v-bind="{ ...$attrs, ...$props }"
    class="no-spinners"
    inputmode="numeric"
    min="0"
    outline
    pattern="[0-9]*" />
</template>

<script>
import TextInputCommon from '@/components/common/TextInputCommon.vue';
import InputCommonMixin from '@/mixins/InputCommonMixin';

export default {
  components: {
    TextInputCommon,
  },
  mixins: [InputCommonMixin],
};
</script>
